import React, {useEffect, useState} from 'react';
import {message, Modal, Upload, Button, Collapse} from 'antd';
import {InboxOutlined, WarningOutlined} from '@ant-design/icons';
import GroupedListSystem from "../misc/GroupedListSystem";
import {ImportTestControllerApi} from "../../api";
import {useKeycloakHeader} from "../../config/Config";
import GroupedList from "../misc/GroupedList";

const {Dragger} = Upload;


const ImportTestModal = ({visible, onClose}) => {
    const [file, setFile] = useState<File | null>();
    const [parsedData, setParsedData] = useState<any>();
    const [newPasswordNames, setNewPasswordNames] = useState<string[]>([]);
    const headers = useKeycloakHeader();

    const importTestControllerApi = new ImportTestControllerApi();

    useEffect(() => {
        fetchPasswordExistingInfo();
    }, [parsedData]);

    const handleUpload = (info) => {

        const {status, originFileObj} = info.file;
        if (status !== 'uploading') {
            console.log(info.file, info.fileList);
        }
        if (status === 'done') {
            message.success(`${info.file.name} file uploaded successfully.`);
            parseFile(originFileObj);
        } else if (status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    };

    const parseFile = (file) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const result = event.target?.result;
                if (typeof result === 'string') {
                    const jsonData = JSON.parse(result);
                    setParsedData(jsonData);
                    setFile(file);
                } else {
                    throw new Error('Invalid file format');
                }
            } catch (error) {
                message.error('Die Datei entspricht nicht dem JSON-Format');
            }
        };
        reader.readAsText(file);
    };

    const handleConfirm = () => {
        console.log(parsedData);
        if (file) {
            importTestControllerApi.uploadFile(file, headers).then((response) => {
                message.success("Datei erfolgreich hochgeladen");
                onClose();
            }).catch((error) => {
                message.error("Datei konnte nicht hochgeladen werden!");
            })
        }
    };

    const removeFile = () => {
        setFile(null);
        setParsedData([]);
        setNewPasswordNames([]);
    }

    const fetchPasswordExistingInfo = () => {

        if (!(parsedData && parsedData.passwords)) return;

        const passwordNames = parsedData.passwords.map(p => p.name);

        importTestControllerApi.checkPasswords(passwordNames, headers).then((response) => {
            let newPasswords = response.data;
            setNewPasswordNames(newPasswords);
        })
    }

    return (
        <>
            <Modal open={visible} onCancel={onClose} onOk={handleConfirm} title="Importiere die Daten" width={800}
                   okText="Bestätigen"
                   cancelText="Abbrechen">
                <Dragger name="file" beforeUpload={(file) => {
                    parseFile(file);
                    return false;
                }}
                         onChange={handleUpload} disabled={!!file} showUploadList={false}>
                    {!file ? (
                        <>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined/>
                            </p>
                            <p className="ant-upload-text">
                                Klicke oder ziehe eine Datei in diesen Bereich, um sie hochzuladen
                            </p>
                            <p className="ant-upload-hint">
                                Unterstützt wird nur der Upload einer einzelnen JSON-Datei.
                            </p>
                        </>
                    ) : (
                        <p>Datei "{file.name}" wurde hochgeladen.</p>
                    )}
                </Dragger>
                {file && (
                    <div style={{display: 'flex', justifyContent: 'center', marginTop: 10}}>
                        <Button onClick={removeFile}>
                            Datei entfernen
                        </Button>
                    </div>
                )}
                {file &&
                    <Collapse accordion style={{marginTop: '5px'}}>
                        {(parsedData && parsedData.tests && parsedData.tests.length > 0) &&
                            <Collapse.Panel key={'tests'} header={'Tests'}>
                              <GroupedListSystem exportDataList={parsedData.tests}/>
                            </Collapse.Panel>}
                        {(parsedData && parsedData.prefabs && parsedData.prefabs.length > 0) &&
                            <Collapse.Panel key={'prefabs'} header={'Komponenten'}>
                              <GroupedListSystem exportDataList={parsedData.prefabs}/>
                            </Collapse.Panel>}
                        {(parsedData && parsedData.systems && parsedData.systems.length > 0) &&
                            <Collapse.Panel key={'systems'} header={'Systeme'}>
                              <GroupedList exportDataList={parsedData.systems}/>
                            </Collapse.Panel>}
                        {(parsedData && parsedData.passwords && parsedData.passwords.length > 0) &&
                            <Collapse.Panel key={'passwords'} header={'Passwörter'}>
                              <GroupedList exportDataList={parsedData.passwords}/>
                            </Collapse.Panel>}
                    </Collapse>}
                {(newPasswordNames && newPasswordNames.length > 0) &&
                    <div style={{
                        marginTop: '5px',
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: '#e82121',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        color: 'white',
                        fontWeight: 'bold'
                    }}>
                      <WarningOutlined style={{marginRight: 8, fontSize: '16px'}}/>
                      <span style={{fontSize: "14px"}}>
                        Achtung, folgende Passwörter:
                        <ul style={{margin: 0, paddingLeft: "20px"}}>
                          {newPasswordNames.map((name, index) => (
                              <li key={index}>{name}</li>
                          ))}
                        </ul>
                        müssen neu vergeben werden!
                      </span>
                    </div>
                }
            </Modal>
        </>
    );
};

export default ImportTestModal;
